import React from 'react';
const ConfirmNewsletterEmail = React.lazy(() => import('~/shared/newsletter_signups/ConfirmNewsletterEmail'));

const confirmNewsletterEmailRoute = {
  path: 'newsletter_signups',
  children: [
    {
      path: 'confirm_email',
      element: <ConfirmNewsletterEmail />
    }
  ]
}

export default confirmNewsletterEmailRoute
